import { useEffect } from "react";

import { useSetRecoilState, useRecoilState } from "recoil";
import {
  flutterMessageSelector,
  webViewSelector,
} from "../../shared/actions/LayoutMode.actions";

export function FlutterMessageHandler() {
  const setFlutterMessage = useSetRecoilState(flutterMessageSelector);
  const [isWebView, setIsWebView] = useRecoilState(webViewSelector);

  useEffect(() => {
    window.flutterMessage = (message) => {
      setFlutterMessage(message);

      //Kadirle bak flutter mesajları nerelerde geliyor eğer sıkıntı çıkarmıyosa
      //mesajı 1 sn sonra sil

      if (message.startsWith("mobilLogin")) {
        setIsWebView(true);
      }
    };
  }, [setFlutterMessage]);

  return null;
}

export default FlutterMessageHandler;

export function postMessageCall(value) {
  window.arama.postMessage(value);
}

export function postMessageWhatsapp(value) {
  window.whatsapp.postMessage(value);
}

export function postMessageSms(value) {
  window.sms.postMessage(value);
}

export function postMessageWp(value) {
  window.wp.postMessage(value);
}

export function postMessageLocation(value) {
  window.konum.postMessage(value);
}

export function postMessageLogin(value) {
  window.login.postMessage(value);
}

export function postMessageLogout(value) {
  window.logout.postMessage(value);
}

export function postMessagePersonelLocation(value) {
  window.personelid.postMessage(value);
}

export function postUserLocation(value) {
  window.musteriProfilKonumGuncelleme.postMessage(value);
}

export function postUserAddLocation(value) {
  window.musteriEklemeKonumGuncelleme.postMessage(value);
}

// export function getFlutterMessage() {
//   let messageFromKadir = "";
//   window.flutterMessage = (message) => {
//     messageFromKadir = message;

//     alert("Message from Flutter: " + messageFromKadir);
//   };

//   return messageFromKadir;
// }
